import { AdCampaignManagerServiceClient } from 'src/utils/adCampaignManagerServiceClient/adCampaignManagerServiceClient';

export { AdCampaignManagerServiceClient };
